// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"118": "lib-router","72": "lib-axios",}[chunkId] || chunkId) + "." + {"118": "733a8e1c","366": "c7d8f862","615": "74da30b9","72": "b31b0f31","762": "4709ff34","883": "e452fa95","974": "ea9f66ba",}[chunkId] + ".js"
}